import { createFileRoute, redirect } from '@tanstack/react-router';
import { isOnboardingIsolated } from '@aegislab/shared';
import { MailConnectionPage } from '@/pages/MailConnectionPage';
import { useAuthStore } from '@/shared/model';

/** Gmail 발신 연결 — 구글 동의 뒤 돌아오는 자리. 가드는 MCP 토큰 화면과 같다. */
export const Route = createFileRoute('/settings/mail')({
  beforeLoad: ({ location }) => {
    const user = useAuthStore.getState().user;
    if (!user) {
      // 구글에서 돌아왔는데 세션이 풀렸으면 로그인 뒤 결과를 들고 이 화면으로 돌아온다.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    // 온보딩 격리: 윈도우 밖 별도 라우트도 격리 안이다 — 홈(온보딩 흐름)으로 돌려보낸다.
    if (isOnboardingIsolated(user)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/' });
    }
  },
  component: MailConnectionPage,
});
